import { z } from 'zod'

import type {
  CommonResponseCollectionHandwrittenNotePresignedUrlResponse,
  CommonResponseHandwrittenNoteTempPresignedUrlResponse,
  HandwrittenNoteUrlsResponse,
} from '~/api-spec/__generated__/main'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type HandwrittenNotePresignedUrl,
  HandwrittenNotePresignedUrlSchema,
  type HandwrittenNoteUrl,
  HandwrittenNoteUrlSchema,
} from './schemas'

const ENTITY = 'HandwrittenNote'

// 스펙은 tag·subId·presignedUrl 을 optional 로 그리지만 서버는 Kotlin nullable 을 키째 null 로 싣는다.
// 스키마가 와이어대로 nullable 을 검증한다.
export const adaptHandwrittenNoteUrls = (raw: HandwrittenNoteUrlsResponse): HandwrittenNoteUrl[] =>
  parseApiResponse(z.object({ content: z.array(HandwrittenNoteUrlSchema) }), raw, ENTITY).content

export const adaptHandwrittenNotePresignedUrls = (
  raw: CommonResponseCollectionHandwrittenNotePresignedUrlResponse['data'],
): HandwrittenNotePresignedUrl[] =>
  parseApiResponse(z.array(HandwrittenNotePresignedUrlSchema), raw, ENTITY)

export const adaptTempPresignedUrl = (
  raw: CommonResponseHandwrittenNoteTempPresignedUrlResponse['data'],
): HandwrittenNotePresignedUrl['presignedUrl'] =>
  parseApiResponse(HandwrittenNotePresignedUrlSchema.pick({ presignedUrl: true }), raw, ENTITY)
    ?.presignedUrl ?? null
